import { Link } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import { getGrade } from "store/slices/user";

export const PrepareSupplies = () => {
  const grade = useAppSelector(getGrade);

  const isFiveOrGraduade = grade === "5" || grade === "maturant";
  /* TODO: translate */
  return (
    <div className="text-center text-muted mb-32px">
      {isFiveOrGraduade ? <span>Nezapomeň dostatek čistých A4 papírů a psací potřeby</span> : null}
      {!isFiveOrGraduade ? (
        <span>
          Nezapomeň dostatek čistých A4 papírů, psací potřeby a{" "}
          <Link
            to={"https://kurzy.ssgh.cz/wp-content/uploads/2026/10/to-das_pomocne_vzorecky.pdf"}
            target="_blank"
            rel="noopener noreferrer"
          >
            vytištěné pomocné vzorečky
          </Link>
        </span>
      ) : null}
    </div>
  );
};
